<!-- 商品详情 -->
<template>
  <div class="goods-detail-container">
    <title></title>
    <van-swipe :autoplay="3000" indicator-color="white">
      <van-swipe-item class="header-img-item" v-for="(img, index) in productDetail.images" :key="index">
        <img :src="img" @click="viewHeaderImg(index)">
      </van-swipe-item>
    </van-swipe>
    <div class="goods-desc">
      <div class="show">
        <h2>{{productDetail.name}}</h2>
        <div class="exchange">
          <div class="exchange-price">
            <img src="../../assets/icon/icons8-expensive_2@2x.png">
            <div>{{productDetail.credit}}</div>
          </div>
        </div>
      </div>
      <span>{{productDetail.intro}}</span>
      <div class="detail">
        <p>价值：<span>￥{{productDetail.price}} 元</span></p>
        <p>已兑换：{{ productDetail.exchanged }}</p>
      </div>
    </div>
    <div class="goods-detail-wrapper" v-if="productDetail.attachments.length">
      <p>商品详情</p>
      <div class="detail-item" v-for="img in productDetail.attachments" :key="img">
        <img :src="img" />
      </div>
    </div>
    <div class="button" @click="toExchange">立即兑换</div>
  </div>
</template>

<script>

import Vue from 'vue'
import { Swipe, SwipeItem, ImagePreview } from 'vant'

Vue.use(Swipe).use(SwipeItem).use(ImagePreview)

export default {
  data() {
    return {
      productDetail: { attachments: [] }
    }
  },
  mounted() {
  },
  created() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      var that = this
      this.axios.get('/product/' + this.$route.query.id).then(function(res) {
        console.log(res.data)
        that.productDetail = res.data
        document.title = that.productDetail.name
        console.log(that.productDetail)
      }).catch(function(error) {
        console.log(error)
      })
    },

    /**
     * 查看头图详情
     */
    viewHeaderImg(index) {
      ImagePreview(this.productDetail.images, index)
    },

    /**
     * 去兑换
     */
    toExchange() {
      this.$router.push({ path: '/goods/exchange', query: { productId: this.$route.query.id }})
    }
  }
}
</script>

<style lang="scss" scoped>
.goods-detail-container {
  .header-img-item {
    display: block;
    img{
      width: 100%;
      height: 375px;
    }
  }
  .goods-desc{
    padding: 10px;
    background-color: #ffffff;
    .show {
      display: flex;
      justify-content: space-between;
      .exchange{
      align-self: flex-start;
      padding: 0 5px;
        .exchange-price{
          padding: 2px 0px 1px 0px;
          width: 65px;
          display: inline-block;
          img {
            width: 16px;
            height: 16px;
            display: inline-block;
            vertical-align: top;
          }
          div {
            font-size: 14px;
            display: inline-block;
            vertical-align: top;
          }
        }
      }
    }
    span{
      color: #9b9b9b;
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
      display: inline-block;
      margin: 10px 0;
    }
    .detail{
      display: flex;
      align-items: center;
      justify-content: space-between;
      p{
        color: #9b9b9b;
        font-size: 12px;
        font-weight: 400;
        span{
          color: #ff6d63;
          font-size: 14px;
          font-weight: 600;
        }
      }
    }
  }
  .goods-detail-wrapper {
    margin: 10px 0 66px 0;
    background: #fff;
    p {
      font-size: 14px;
      color: #4A4A4A;
      letter-spacing: 0;
      height: 40px;
      line-height: 40px;
      padding: 0 15px;
    }
    .detail-item {
      width: 100%;
      margin: 0;
      img {
        width: 100%;
      }
    }
  }
  .button{
    width: 100%;
    height: 66px;
    background-color: #0d2e52;
    text-align: center;
    line-height: 66px;
    color: #ffffff;
    font-size: 18px;
    font-weight: 600;
    position: fixed;
    bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/goods/detail.vue